
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vermietung",
      function () {
        return require("private-next-pages/vermietung/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vermietung"])
      });
    }
  